"use strict";
/**
 * Domain Value Objects for Manulife Insurance Domain.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiderConfig = exports.ProductPlan = exports.ProductCode = exports.MANULIFE_PRODUCT_OPTIONS = exports.UL050_PRODUCT_CODES = exports.UL_PRODUCT_CODES = exports.PAYMENT_FREQUENCY_OPTIONS = exports.SumAssured = exports.TermInYears = exports.Age = exports.Money = void 0;
const base_1 = require("./base");
class Money extends base_1.BaseValueObject {
    _amount;
    constructor(amount) {
        super();
        if (amount < 0) {
            throw new base_1.BaseDomainException('Money amount cannot be negative');
        }
        this._amount = amount;
    }
    get amount() {
        return this._amount;
    }
    add(other) {
        return new Money(this._amount + other.amount);
    }
    multiply(factor) {
        return new Money(this._amount * factor);
    }
    formatVND() {
        return `${this._amount.toLocaleString('vi-VN')} VNĐ`;
    }
}
exports.Money = Money;
class Age extends base_1.BaseValueObject {
    _years;
    constructor(years) {
        super();
        if (!Number.isInteger(years) || years < 0 || years > 100) {
            throw new base_1.BaseDomainException(`Invalid age: ${years}. Must be an integer between 0 and 100.`);
        }
        this._years = years;
    }
    get years() {
        return this._years;
    }
}
exports.Age = Age;
class TermInYears extends base_1.BaseValueObject {
    _years;
    constructor(years, minYears = 10, maxYears = 20) {
        super();
        if (!Number.isInteger(years) || years < minYears || years > maxYears) {
            throw new base_1.BaseDomainException(`Term ${years} years is invalid. Must be between ${minYears} and ${maxYears} years.`);
        }
        this._years = years;
    }
    get years() {
        return this._years;
    }
}
exports.TermInYears = TermInYears;
class SumAssured extends base_1.BaseValueObject {
    _amount;
    constructor(amount, minAmount = 500_000_000, maxAmount = 900_000_000) {
        super();
        if (amount < minAmount || amount > maxAmount) {
            throw new base_1.BaseDomainException(`Sum Assured ${amount.toLocaleString('vi-VN')} VNĐ is out of allowed range [${minAmount.toLocaleString('vi-VN')}, ${maxAmount.toLocaleString('vi-VN')}].`);
        }
        this._amount = amount;
    }
    get amount() {
        return this._amount;
    }
}
exports.SumAssured = SumAssured;
exports.PAYMENT_FREQUENCY_OPTIONS = [
    { code: 'Năm', label: 'Năm', factor: 1.0 },
    { code: 'Nửa năm', label: 'Nửa năm', factor: 0.52 },
    { code: 'Quý', label: 'Quý', factor: 0.27 },
    { code: 'Tháng', label: 'Tháng', factor: 0.09 },
];
exports.UL_PRODUCT_CODES = {
    UL049_FIXED: 'UL049 - Lựa chọn STBH không tự động gia tăng',
    FIXED: 'UL050 - Lựa chọn STBH không tự động gia tăng',
    AUTO_INCREASING: 'UL050 - Lựa chọn STBH tự động gia tăng',
};
exports.UL050_PRODUCT_CODES = exports.UL_PRODUCT_CODES;
exports.MANULIFE_PRODUCT_OPTIONS = [
    {
        code: exports.UL_PRODUCT_CODES.UL049_FIXED,
        label: 'UL049 - Lựa chọn STBH không tự động gia tăng',
        stbhOption: 'KHONG_TU_DONG_GIA_TANG',
    },
    {
        code: exports.UL_PRODUCT_CODES.FIXED,
        label: 'UL050 - Lựa chọn STBH không tự động gia tăng',
        stbhOption: 'KHONG_TU_DONG_GIA_TANG',
    },
    {
        code: exports.UL_PRODUCT_CODES.AUTO_INCREASING,
        label: 'UL050 - Lựa chọn STBH tự động gia tăng',
        stbhOption: 'TU_DONG_GIA_TANG',
    },
];
class ProductCode extends base_1.BaseValueObject {
    _code;
    _stbhOption;
    constructor(code) {
        super();
        if (!code || !code.trim()) {
            throw new base_1.BaseDomainException('Product code cannot be empty');
        }
        this._code = code.trim();
        if (this._code === exports.UL_PRODUCT_CODES.FIXED || this._code === exports.UL_PRODUCT_CODES.UL049_FIXED) {
            this._stbhOption = 'KHONG_TU_DONG_GIA_TANG';
        }
        else if (this._code === exports.UL_PRODUCT_CODES.AUTO_INCREASING) {
            this._stbhOption = 'TU_DONG_GIA_TANG';
        }
    }
    get code() {
        return this._code;
    }
    get stbhOption() {
        return this._stbhOption;
    }
    isAutoIncreasing() {
        return this._stbhOption === 'TU_DONG_GIA_TANG';
    }
}
exports.ProductCode = ProductCode;
class ProductPlan extends base_1.BaseValueObject {
    _planName;
    constructor(planName) {
        super();
        if (planName !== 'Cơ bản' && planName !== 'Nâng cao') {
            throw new base_1.BaseDomainException(`Invalid Product Plan: '${planName}'. Must be 'Cơ bản' or 'Nâng cao'.`);
        }
        this._planName = planName;
    }
    get planName() {
        return this._planName;
    }
}
exports.ProductPlan = ProductPlan;
class RiderConfig extends base_1.BaseValueObject {
    _riderId;
    _riderName;
    _sumAssured;
    _annualPremium;
    constructor(riderId, riderName, sumAssured, annualPremium) {
        super();
        if (!riderId || !riderName) {
            throw new base_1.BaseDomainException('Rider ID and Rider Name cannot be empty');
        }
        this._riderId = riderId;
        this._riderName = riderName;
        this._sumAssured = sumAssured;
        this._annualPremium = annualPremium;
    }
    get riderId() {
        return this._riderId;
    }
    get riderName() {
        return this._riderName;
    }
    get sumAssured() {
        return this._sumAssured;
    }
    get annualPremium() {
        return this._annualPremium;
    }
}
exports.RiderConfig = RiderConfig;
